<template>
  <div>
    <div style="width: 40px; height: 40px;margin-bottom: 10px">
      <imgpop
          v-show="typeof imgUrl === 'string'"
          :imgUrl="imgUrl"
      />
    </div>
    <el-upload
        ref="upload"
        class="upload-demo"
        action="/all-elements/api/v1/other/uploadFile"
        :limit="1"
        :on-success="uploadBackheaderEdit"
        :auto-upload="true"
        :headers="headers"
        :show-file-list="showFileList"
        :file-list="fileList"
    >
      <!--        :file-list="picfileListZsmb"-->

      <template #trigger>
        <yz-button1 type="primary">上传照片</yz-button1>
      </template>
       <div class="el-upload" style="margin-left: 12px"><yz-button0 @click="deleteImg">删除照片</yz-button0> </div>
<!--      <template #file></template>-->
    </el-upload>
  </div>
</template>

<script>
import {getFileUrl} from "@/request/BasicDataApi";

export default {
  name: "index",
  props: ['url'],
  data() {
    return {
      // url: "", //照片预览地址
      headers: {
        token: sessionStorage.getItem("token"),
      },
      // picfileListZsmb: [], //上传照片数组
      fileList:[],
      imgUrl: null,
      showFileList: false,
    }
  },

  created() {
    // this.
    this.imgUrl = null
    if (this.url != null) {
      this.showFileList = true
      this.imgUrl = this.url
    }
  },
  mounted() {
    if (this.url == null) {
      console.log('clear',this.$refs['upload'])
      this.$refs['upload'].clearFiles()
    }
  },
  methods: {
    // todo 图片列表 上传新的图片顶掉旧的图片
    //修改上传照片
    uploadBackheaderEdit(e) {
      if (e.code == 0) {
        // this.picfileListZsmb = [];
        // console.log(e.data);
        this.$emit('imgUrl', e.data)
      }
    },

    deleteImg(){
      this.$emit('imgUrl', ' ')
      this.$refs['upload'].clearFiles()
    }
  },
  watch: {
    'imgUrl'(e) {
      if(e == null) {
        this.showFileList = false
        this.$refs['upload'].clearFiles()
      }
    },
    'url'(e) {
      this.imgUrl = e
    }
  },
}
</script>

<style scoped>

</style>
